'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherGift, FeatherShield, FeatherZap } from '@subframe/core';
import { Button, LogoArbitralis } from '@/shared/components/ui';
import { SALDO_PRESENTE_ANUNCIADO } from '../constants';
import type { UseOnboardingSelfReturn } from '../hooks';
interface InicioScreenProps {
  vm: UseOnboardingSelfReturn;
}
const HERO = '/images/hero-onboarding-self.webp';
export const InicioScreen = t0 => {
  const $ = _c(20);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      icone: <FeatherZap className="text-brand-600" />,
      titulo: "Comece em minutos",
      descricao: "Sem burocracia, sem espera."
    }, {
      icone: <FeatherShield className="text-brand-600" />,
      titulo: "Seus dados protegidos",
      descricao: "Em conformidade com a LGPD."
    }, {
      icone: <FeatherGift className="text-brand-600" />,
      titulo: `${SALDO_PRESENTE_ANUNCIADO.toLocaleString("pt-BR")} envios de presente`,
      descricao: "Liberados no fim do cadastro."
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const destaques = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LogoArbitralis className="flex-none self-start [&_img]:h-6 [&_img]:w-auto" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="border-brand-100 bg-brand-50 flex w-fit items-center gap-2 rounded-full border border-solid px-3 py-1"><span className="bg-brand-600 os-pulse-dot h-2 w-2 rounded-full" /><span className="text-brand-700 text-xs font-semibold">Criar conta na Arbitralis</span></span>;
    t4 = <h1 className="text-heading-dark text-[32px] leading-tight font-semibold tracking-tight text-pretty sm:text-[40px] lg:text-[44px]">Sua empresa resolvendo conflitos sem sair da mesa</h1>;
    t5 = <p className="max-w-[480px] text-base leading-relaxed text-pretty text-neutral-700">Notificação extrajudicial, negociação com IA e arbitragem digital em uma só plataforma. Você escolhe o que vai usar e já sai daqui com saldo para começar.</p>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherArrowRight />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== vm) {
    t7 = <Button size="large" className="mt-2 self-start text-base" iconRight={t6} onClick={() => vm.goTo("empresa")}>Vamos começar</Button>;
    $[6] = vm;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-[13px] text-neutral-500">Recebeu uma notificação e quer responder?</span>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== vm.abrirAviso) {
    t9 = <div className="mt-1 flex flex-wrap items-center gap-2">{t8}<button type="button" onClick={vm.abrirAviso} className="text-brand-600 hover:text-brand-400 text-[13px] font-semibold underline transition-colors">Ir para o painel do notificado</button></div>;
    $[9] = vm.abrirAviso;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t9) {
    t10 = <div className="flex max-w-[560px] flex-1 flex-col justify-center gap-6">{t3}{t4}{t5}{t7}{t9}</div>;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-wrap gap-8 border-t border-solid border-neutral-100 pt-6">{destaques.map(_temp)}</div>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10) {
    t12 = <div className="flex flex-1 flex-col justify-between gap-10 px-6 py-12 sm:px-10 sm:py-14 lg:px-16">{t2}{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="hidden bg-cover bg-center bg-no-repeat lg:block lg:min-h-screen lg:w-1/2" style={{
      backgroundImage: `url('${HERO}')`
    }} role="presentation" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <div className="flex min-h-screen w-full flex-col overflow-hidden bg-white lg:flex-row">{t12}{t13}</div>;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
};
function _temp(destaque) {
  return <div key={destaque.titulo} className="flex max-w-[260px] items-center gap-3"><div className="bg-brand-50 flex h-10 w-10 flex-none items-center justify-center rounded-[12px]">{destaque.icone}</div><div><div className="text-heading-dark text-sm font-semibold">{destaque.titulo}</div><div className="text-xs text-neutral-500">{destaque.descricao}</div></div></div>;
}